module.exports = __webpack_public_path__ + "static/media/island_press_1.242638b7.jpg";